var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',_vm._l((_vm.schema),function(ref,index){
var name = ref.name;
var fields = ref.fields;
return _c('base-section',{key:index,attrs:{"name":name,"is-done":_vm.isDone(fields)}},[_vm._t("beforeFields",null,{"sectionName":name,"fields":fields}),_c('base-fields',{attrs:{"initial-values":_vm.initialValues,"fields":fields,"meta":_vm.meta},on:{"updateMeta":_vm.updateValueMeta,"updateSchema":_vm.updateSchema}})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }